import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        button: 'onClickButton',
      },
    }
  }

  init() {
    this.state = {
      type: false,
      year: false,
    }

    this.filters = document.querySelectorAll('.c-filter')
    this.controller()
  }

  syncState() {
    this.call('updateState', this.state, 'Increment')
  }

  controller() {
    this.filters.forEach((filter) => {
      const { taxonomy } = filter.dataset
      const button = filter.querySelector('[data-filter="button"]')
      const innerButtonText = button.querySelector('.c-filter__button__selected')
      const options = filter.querySelectorAll('[data-filter-option]')
      const clearButton = filter.querySelector('[data-filter="clear"]')

      button?.addEventListener('click', () => {
        filter.classList.toggle('has-list-opened')
      })

      options.forEach((option) => {
        option.addEventListener('click', () => {
          const selectedOption = option.innerText

          const value = option.dataset.filterValue

          if (value !== 'all') {
            this.state[taxonomy] = value
            innerButtonText.innerText = selectedOption
            button.classList.add('has-option-selected')
            clearButton.style.display = 'inline-block'
          } else {
            this.state[taxonomy] = false
            innerButtonText.innerText = ''
            button.classList.remove('has-option-selected')
            clearButton.style.display = 'none'
          }

          this.syncState()

          options.forEach((item) => {
            item.classList.remove('is-active')
          })

          option.classList.add('is-active')
        })
      })

      clearButton.addEventListener('click', () => {
        this.state[taxonomy] = false
        innerButtonText.innerText = ''
        button.classList.remove('has-option-selected')
        clearButton.style.display = 'none'

        this.syncState()

        options.forEach((item) => {
          item.classList.remove('is-active')
        })
      })

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-filter]')) return
        filter.classList.remove('has-list-opened')
      })
    })
  }
}
